import { Box, Button } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { offerTokenChoices } from '../shared/offerTokens';
import { CARD_BARCODE_ANCHOR } from './cashdeskBlocks';
import ToolPanel from './ToolPanel';

interface CashdeskOfferPanelProps {
  offerCount: number;
  onInsert: (anchor: string) => void;
}

const codeButtonSx = (color: string) => ({ textTransform: 'none' as const, fontSize: '0.78rem', borderColor: color, color, borderRadius: 1.5 });

function CashdeskOfferPanel({ offerCount, onInsert }: CashdeskOfferPanelProps) {
  const offerCodes = offerTokenChoices(offerCount);

  return (
    <ToolPanel icon={<QrCode2Icon sx={{ fontSize: '1rem' }} />} title="Code opération">
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
        {offerCodes.map((code, index) => (
          <Button key={code} variant="outlined" size="small" onClick={() => onInsert(code)} sx={codeButtonSx('primary.main')}>
            {`Insérer un code barre ${index + 1}`}
          </Button>
        ))}
        <Button variant="outlined" size="small" onClick={() => onInsert(CARD_BARCODE_ANCHOR)} sx={codeButtonSx('text.secondary')}>
          Insérer le code barre carte
        </Button>
      </Box>
    </ToolPanel>
  );
}

export default CashdeskOfferPanel;
